export const DETAILED_TRANSACTION_HISTORY = 'detailedtransactionhistory';

export const MOBILE_VIEW_WIDTH_THRESHOLD = 700;

export const ONE_MONTH_VALUE = 1;

export const LAST_24_HOURS_VALUE = 1;
export const LAST_7_DAYS_VALUE = 7;
export const LAST_MONTH_VALUE = 30;
export const LAST_3_MONTHS_VALUE = 90;
export const LAST_SIX_MONTHS = 180;
export const ANOTHER_PERIOD_VALUE = -1;

export const DEFAULT_PAGE_SIZE = 30;
export const EXPORT_PAGE_SIZE = 100;

export const CASINO_GAMING_BALANCE = 'casino_gaming_balance';

export const STATUSES = Object.freeze({
    ALL: 'all',
    PENDING: 'pending',
    WAITING: 'waiting',
    APPROVED: 'approved',
    DECLINED: 'declined',
    CANCELLED: 'cancelled'
});

export const TYPES = Object.freeze({
    ALL: 'all',
    DEPOSIT: 'deposit',
    WITHDRAW: 'withdraw'
});

export const FILTERS = Object.freeze({
    PERIOD: 'period',
    STATUS: 'status',
    TYPE: 'type'
});
